import { default as api } from 'config/authApiConf.js';

export const listBlogService = async (page = 1) => {
	try {
		let result = await api.get(`/cms/list-blog?page=${page}`);
		return result;
	} catch (error) {
		return error;
	}
};
